var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vessel-track-map",class:{ 'is-sea': _vm.baseMode === 'sea' }},[_c('div',{ref:"mapEl",staticClass:"vessel-track-map__canvas"}),(_vm.loading)?_c('div',{staticClass:"vessel-track-map__mask"},[_vm._v("地图加载中…")]):_vm._e(),(_vm.loadError)?_c('div',{staticClass:"vessel-track-map__mask"},[_vm._v(_vm._s(_vm.loadError))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }